import appleLogo from '/public/logos/apple-logo.svg'
import googleLogo from '/public/logos/google-logo.svg'
import microsoftLogo from '/public/logos/microsoft-logo.svg'

export const SSO_PROVIDERS = [
  {
    provider: 'google',
    img: {
      src: googleLogo,
      alt: 'Google'
    }
  },
  {
    provider: 'azure',
    img: {
      src: microsoftLogo,
      alt: 'Microsoft'
    }
  },
  {
    provider: 'apple',
    img: {
      src: appleLogo,
      alt: 'Apple'
    }
  }
] as const
